import {Component, Injectable, inject} from "@angular/core";
import {MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {util} from 'app/ajs-upgraded-providers';
import {MagicPortalDialogComponent} from "../magic-portal-dialog";
import { BaseDialogService, TilbyDialogContentComponent, TilbyDialogToolbarComponent } from "@tilby/tilby-ui-lib/components/tilby-dialog";
import { lastValueFrom } from "rxjs";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { BillingDataService, SUPPORT_URLS } from "src/app/core";

@Component({
    selector: 'app-support-dialog',
    host: {class:'settingsTheme supportDialog'},
    templateUrl: './support-dialog.component.html',
    standalone: true,
    imports: [CommonModule, TilbyDialogToolbarComponent, TilbyDialogContentComponent, MatDialogModule, MatButtonModule, MatIconModule, TranslateModule]
})
export class SupportDialogComponent {
        private readonly dialogRef= inject(MatDialogRef<MagicPortalDialogComponent<SupportDialogComponent>>);
        private readonly util: any = inject(util);
        private readonly billingDataService = inject(BillingDataService);

        protected adHocCode = this.billingDataService.adHocCode;

    hide() {
        this.dialogRef.close();
    }

    cancel() {
        this.dialogRef.close();
    }

    consultManuals() {
        this.util.openExternalLink(SUPPORT_URLS.manuals);
        this.hide();
    }

    getSupport() {
        this.util.openExternalLink(SUPPORT_URLS.getSupport);
        this.hide();
    }

    shareScreen() {
        this.util.openExternalLink(SUPPORT_URLS.shareScreen);
        this.hide();
    }

}

@Injectable({
    providedIn: 'root'
})
export class SupportDialogService extends BaseDialogService {
    private readonly dialogRef = inject(MatDialog);

    public openDialog(config?: MatDialogConfig){
        const configEdited: MatDialogConfig={...this.switchMobileDesktopDimensions(), disableClose:true, ...config, panelClass: 'support-dialog-container'};
        return lastValueFrom(this.dialogRef.open(SupportDialogComponent,configEdited).afterClosed());
    }
}
